import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { changeSort } from "../../../Filters/store/filterSlice";

import SelectItem from "../../../../ui/SelectItem";

const optionsType = [
	{ value: 'area_asc', label: (
		<>
			по площади
			<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
				<path d="M2 11.3333C2 11.7015 2.29848 12 2.66667 12H13.3333C13.7015 12 14 11.7015 14 11.3333C14 10.9651 13.7015 10.6667 13.3333 10.6667H2.66667C2.29848 10.6667 2 10.9651 2 11.3333ZM2.66667 4C2.29848 4 2 4.29848 2 4.66667C2 5.03486 2.29848 5.33333 2.66667 5.33333H5.33333C5.70152 5.33333 6 5.03486 6 4.66667C6 4.29848 5.70152 4 5.33333 4L2.66667 4ZM2 8C2 8.36819 2.29848 8.66667 2.66667 8.66667H9.33333C9.70152 8.66667 10 8.36819 10 8C10 7.63181 9.70152 7.33333 9.33333 7.33333H2.66667C2.29848 7.33333 2 7.63181 2 8Z" fill="#010620"/>
			</svg>
		</>
	) },
	{ value: 'area_desc', label: (
		<>
			по площади
			<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
				<path d="M2 11.3333C2 11.7015 2.29848 12 2.66667 12H5.33333C5.70152 12 6 11.7015 6 11.3333C6 10.9651 5.70152 10.6667 5.33333 10.6667H2.66667C2.29848 10.6667 2 10.9651 2 11.3333ZM2.66667 4C2.29848 4 2 4.29848 2 4.66667C2 5.03486 2.29848 5.33333 2.66667 5.33333H13.3333C13.7015 5.33333 14 5.03486 14 4.66667C14 4.29848 13.7015 4 13.3333 4H2.66667ZM2 8C2 8.36819 2.29848 8.66667 2.66667 8.66667H9.33333C9.70152 8.66667 10 8.36819 10 8C10 7.63181 9.70152 7.33333 9.33333 7.33333H2.66667C2.29848 7.33333 2 7.63181 2 8Z" fill="#010620"/>
			</svg>
		</>
	) },
	{ value: 'price_asc', label: (
		<>
			по цене
			<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
				<path d="M2 11.3333C2 11.7015 2.29848 12 2.66667 12H13.3333C13.7015 12 14 11.7015 14 11.3333C14 10.9651 13.7015 10.6667 13.3333 10.6667H2.66667C2.29848 10.6667 2 10.9651 2 11.3333ZM2.66667 4C2.29848 4 2 4.29848 2 4.66667C2 5.03486 2.29848 5.33333 2.66667 5.33333H5.33333C5.70152 5.33333 6 5.03486 6 4.66667C6 4.29848 5.70152 4 5.33333 4L2.66667 4ZM2 8C2 8.36819 2.29848 8.66667 2.66667 8.66667H9.33333C9.70152 8.66667 10 8.36819 10 8C10 7.63181 9.70152 7.33333 9.33333 7.33333H2.66667C2.29848 7.33333 2 7.63181 2 8Z" fill="#010620"/>
			</svg>
		</>
	) },
	{ value: 'price_desc', label: (
		<>
			по цене
			<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
				<path d="M2 11.3333C2 11.7015 2.29848 12 2.66667 12H5.33333C5.70152 12 6 11.7015 6 11.3333C6 10.9651 5.70152 10.6667 5.33333 10.6667H2.66667C2.29848 10.6667 2 10.9651 2 11.3333ZM2.66667 4C2.29848 4 2 4.29848 2 4.66667C2 5.03486 2.29848 5.33333 2.66667 5.33333H13.3333C13.7015 5.33333 14 5.03486 14 4.66667C14 4.29848 13.7015 4 13.3333 4H2.66667ZM2 8C2 8.36819 2.29848 8.66667 2.66667 8.66667H9.33333C9.70152 8.66667 10 8.36819 10 8C10 7.63181 9.70152 7.33333 9.33333 7.33333H2.66667C2.29848 7.33333 2 7.63181 2 8Z" fill="#010620"/>
			</svg>
		</>
	) },
]

const optionsTypeEn = [
	{ value: 'area_asc', label: (
		<>
			by area
			<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
				<path d="M2 11.3333C2 11.7015 2.29848 12 2.66667 12H13.3333C13.7015 12 14 11.7015 14 11.3333C14 10.9651 13.7015 10.6667 13.3333 10.6667H2.66667C2.29848 10.6667 2 10.9651 2 11.3333ZM2.66667 4C2.29848 4 2 4.29848 2 4.66667C2 5.03486 2.29848 5.33333 2.66667 5.33333H5.33333C5.70152 5.33333 6 5.03486 6 4.66667C6 4.29848 5.70152 4 5.33333 4L2.66667 4ZM2 8C2 8.36819 2.29848 8.66667 2.66667 8.66667H9.33333C9.70152 8.66667 10 8.36819 10 8C10 7.63181 9.70152 7.33333 9.33333 7.33333H2.66667C2.29848 7.33333 2 7.63181 2 8Z" fill="#010620"/>
			</svg>
		</>
	) },
	{ value: 'area_desc', label: (
		<>
			by area
			<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
				<path d="M2 11.3333C2 11.7015 2.29848 12 2.66667 12H5.33333C5.70152 12 6 11.7015 6 11.3333C6 10.9651 5.70152 10.6667 5.33333 10.6667H2.66667C2.29848 10.6667 2 10.9651 2 11.3333ZM2.66667 4C2.29848 4 2 4.29848 2 4.66667C2 5.03486 2.29848 5.33333 2.66667 5.33333H13.3333C13.7015 5.33333 14 5.03486 14 4.66667C14 4.29848 13.7015 4 13.3333 4H2.66667ZM2 8C2 8.36819 2.29848 8.66667 2.66667 8.66667H9.33333C9.70152 8.66667 10 8.36819 10 8C10 7.63181 9.70152 7.33333 9.33333 7.33333H2.66667C2.29848 7.33333 2 7.63181 2 8Z" fill="#010620"/>
			</svg>
		</>
	) },
	{ value: 'price_asc', label: (
		<>
			by price
			<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
				<path d="M2 11.3333C2 11.7015 2.29848 12 2.66667 12H13.3333C13.7015 12 14 11.7015 14 11.3333C14 10.9651 13.7015 10.6667 13.3333 10.6667H2.66667C2.29848 10.6667 2 10.9651 2 11.3333ZM2.66667 4C2.29848 4 2 4.29848 2 4.66667C2 5.03486 2.29848 5.33333 2.66667 5.33333H5.33333C5.70152 5.33333 6 5.03486 6 4.66667C6 4.29848 5.70152 4 5.33333 4L2.66667 4ZM2 8C2 8.36819 2.29848 8.66667 2.66667 8.66667H9.33333C9.70152 8.66667 10 8.36819 10 8C10 7.63181 9.70152 7.33333 9.33333 7.33333H2.66667C2.29848 7.33333 2 7.63181 2 8Z" fill="#010620"/>
			</svg>
		</>
	) },
	{ value: 'price_desc', label: (
		<>
			by price
			<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
				<path d="M2 11.3333C2 11.7015 2.29848 12 2.66667 12H5.33333C5.70152 12 6 11.7015 6 11.3333C6 10.9651 5.70152 10.6667 5.33333 10.6667H2.66667C2.29848 10.6667 2 10.9651 2 11.3333ZM2.66667 4C2.29848 4 2 4.29848 2 4.66667C2 5.03486 2.29848 5.33333 2.66667 5.33333H13.3333C13.7015 5.33333 14 5.03486 14 4.66667C14 4.29848 13.7015 4 13.3333 4H2.66667ZM2 8C2 8.36819 2.29848 8.66667 2.66667 8.66667H9.33333C9.70152 8.66667 10 8.36819 10 8C10 7.63181 9.70152 7.33333 9.33333 7.33333H2.66667C2.29848 7.33333 2 7.63181 2 8Z" fill="#010620"/>
			</svg>
		</>
	) },
]

const SortItem = () => {

	const dispatch = useDispatch();

	const isEnglish = document.body.classList.contains('en');

	const onChangeSort = (value) => {
		dispatch(changeSort(value.value));
	}

	return (
		<div className="sort">
			<span>{isEnglish ? 'Sort' : 'Сортировать'}</span>
			<SelectItem options={isEnglish ? optionsTypeEn : optionsType} onChange={onChangeSort} placeholder={isEnglish ? optionsTypeEn[0].label : optionsType[0].label} />
		</div>
	);
};

export default SortItem;
